import * as types from "../actionTypes/LoginActionTypes";
import axios from '../../Uri';
import * as apis from "../api/api";
export const validateUsers=(email,password)=>(dispatch)=>{
    axios.get(`/login/getUsersByUserEmailId?email=${email}&password=${password}`).then((response)=>{
    dispatch(getUser(response.data));
    dispatch(userStatus(true))
    }).catch((error)=>{
        console.log(error);
        dispatch(userStatus(false))
    });
    type: types.VALIDATE_LOGIN_ACCESS;
    payload: email, password; 
    return response;
}
export const userStatus=(status)=>({
    type: types.GET_USER_STATUS,
    payload: status,
})
export const getUser = (user) => ({
    type: types.GET_LOGIN_USER,
    payload: user ,
});

export const getLoginHistory=(pageNumber) => (dispatch) => {
    axios.get(`/info?pageNumber=${pageNumber}&pageSize=25&sortBy=id&sortDir=desc`).then((response)=> {
      const apiRes = response.data;
      console.log(apiRes);
      dispatch({type:types.GET_LOGIN_HISTORY,payload:apiRes})
    }).catch((error)=>{
      console.log(error);
    });
    }
